<div class="version-crud mm-page">
  <h2>{{_(KEYS.VERSION.VERSION)}}</h2>
  <div class="mm-info-layout">
    <dl class="mm-info-summary" *ngIf="version">
      <div>
        <dt><i class="fa fa-info-circle" aria-hidden="true"></i>{{_(KEYS.VERSION.SOFTWARE)}}</dt>
        <dd>myMedax 4</dd>
      </div>
      <div>
        <dt><i class="fa fa-code" aria-hidden="true"></i>{{_(KEYS.VERSION.MAIN_VERSION)}}</dt>
        <dd>{{version}}</dd>
      </div>
    </dl>

    <div class="mm-info-panels">
      <section class="mm-info-panel" *ngIf="versionInfo && versionInfo.mymedax">
        <h3><i class="fa fa-sitemap" aria-hidden="true"></i>{{_(KEYS.VERSION.SERVICES)}}</h3>
        <dl class="mm-info-list">
          <div *ngFor="let service of services('mymedax')">
            <dt>{{service}}</dt>
            <dd>{{versionInfo.mymedax[service] || ''}}</dd>
          </div>
        </dl>
      </section>

      <section class="mm-info-panel" *ngIf="versionInfo && versionInfo.dependencies">
        <h3><i class="fa fa-code-fork" aria-hidden="true"></i>{{_(KEYS.VERSION.DEPENDENCIES)}}</h3>
        <dl class="mm-info-list">
          <div *ngFor="let service of services('dependencies')">
            <dt>{{service}}</dt>
            <dd>{{versionInfo.dependencies[service]}}</dd>
          </div>
        </dl>
      </section>
    </div>
  </div>
</div>
